<template>
    <div class="imageTextResource">
        <div
         class="htmlBox"
         v-for="(item, index) in imageText"
         :key="index"
         v-html="item.content"></div>
    </div>
</template>
<script>
export default {
    props: [ 'imageText' ],
}
</script>
<style lang="scss">
.imageTextResource {
    width: 100%;
    .htmlBox {
        width: 100%;
        img {
            max-width: 100%;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/components/resource/imageTextResource.vue